<template>
  <div class="app-breadcrumb-wrap content-breadcrumb-layout">
    <el-breadcrumb class="app-breadcrumb-left" separator="/" v-if="breadcrumb && breadcrumb.length">
      <div class="inner-breadcrumb">
        <el-breadcrumb-item
          v-for="(item, ind) in breadcrumb"
          :key="item.name + item.path + ind"
          :to="getPath(item)">
          <span class="separator" v-if="(ind !== 0) && item.name">/</span>
          {{ item.name }}
        </el-breadcrumb-item>
      </div>
    </el-breadcrumb>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useStoreGetters } from '@/store/hooks'

const getters = useStoreGetters(['breadcrumb'])

const breadcrumb = computed(() => getters.breadcrumb)

const getPath = (item) => (item.path ? item.path : null)
</script>

<style lang="scss">
.app-breadcrumb-wrap{
  display:flex;
  flex-grow: 1;
  align-items: center;
  flex-direction: row;
  padding:1px 15px;
  border: none;
  margin-top: 14px;
  .inner-breadcrumb {
    display: flex;
    .el-breadcrumb__separator {
      display: none;
    }
    .separator {
      padding: 0 4px 0 8px;
      font-weight: normal;
      color: #606266;
    }
    .el-breadcrumb__inner {
      color: #969799;
      a,
      &.is-link {
        font-weight: normal;
        // color: #323233;
        &:hover {
          color: #2e7eff;
        }
      }
    }
    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      color: #323233;
    }
  }
  .app-breadcrumb-env{
    flex:1;
  }
  .app-breadcrumb-left{
   flex:1;
    &.el-breadcrumb {
      overflow: hidden;
      font-size: 14px;
      line-height: 20px;
      .no-redirect {
        cursor: text;
      }
      .el-breadcrumb__item {
        flex-shrink: 3;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:first-child,
        &:last-child {
          flex-shrink: 0;
        }
        &:nth-last-child(2) {
          flex-shrink: 1;
        }
        &:last-child {
          padding-right: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 240px;
        }
      }
    }
  }
  .app-breadcrumb-right {
    margin-right: 18px;
    width: 175px;
    .brand-select{
      .el-input__inner{
        border: none;
        background: #F6F7FB;
        border-radius: 16px;
        color: #323233;
        padding-left:60px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .el-input__inner::-webkit-input-placeholder {
        color: #323233;
      }
      .el-select__caret{
        color: #9A9A9A;
      }
      .el-input__prefix{
          color: #656566;
          padding-left:10px;
      }
    }
  }
  .a-link {
    cursor: pointer !important;
    font-weight: 700 !important;
    color: #303133 !important;
  }
}
.app-breadcrumb-brand{
  padding: 0;
  >li{
    list-style: none;
    i{
      float: right;
      margin-top: 3px;
      display: none;
    }
  }
  >li.active{
    color: #409EFF;
    font-weight: 700;
    i{
      display: block;
    }
  }
}
.tenant-List{
  min-width: 175px;
  max-width: 240px;
  .el-divider--horizontal{
    margin: 15px 0;
  }
  .el-select-dropdown__item{
    cursor: default;
    padding: 0;
    height: auto;
  }
  .el-select-dropdown__item.selected{
    color:#2E7EFF;
    font-weight: normal;
    background-color: inherit;
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background-color: inherit;
  }
  .divider{
    padding: 0 20px;
    box-sizing: border-box;
    .el-divider__text{
      padding: 0 5px;
      font-size:12px;
      color:#969799;
      font-weight: normal;
      .point{
        padding: 0 2px
      }
    }
  }
}
</style>
